import { ChangeDetectionStrategy, Component } from '@angular/core';

import {
  DialogBodyComponent,
  DialogComponent,
  EmptyStateComponent,
  type IconName,
} from '@core/user-interface-legacy';

export interface TicketEmptyStateData {
  title: string;
  desc: string;
  icon: IconName;
}

@Component({
  selector: 'ask-hr-ticket-empty-state',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <rt-dialog-body class="dialog-body">
      <rt-empty-state
        [icon]="dialogData.icon"
        [title]="dialogData.title"
        [desc]="dialogData.desc"
      />
    </rt-dialog-body>
  `,
  imports: [EmptyStateComponent, DialogBodyComponent],
  styleUrl: './ticket-empty-state.component.less',
})
export class TicketEmptyStateComponent extends DialogComponent<TicketEmptyStateData> {}
